import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'

// reflète "maxDuration" codé en dur côté moteur de réservation (base.js du prestataire)
const MAX_NIGHTS = 30

export default class HeroSearch {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.form = this.el.querySelector('#AVP')
    if (!this.form) return

    this.departureInput = this.el.querySelector('#AVP_date_departure')
    this.hiddenArrival = this.el.querySelector('#AVP_arrivalDate')
    this.hiddenNights = this.el.querySelector('#AVP_nights')

    this.populateGuestCounts()
    this.initDatePicker()
    this.bindSubmit()
  }

  populateGuestCounts() {
    this.fillSelect('#selectedAdultCount', 1, 9, 2)
    this.fillSelect('#selectedChildCount', 0, 9, 0)
    this.fillSelect('#selectedInfantCount', 0, 9, 0)
  }

  fillSelect(selector, min, max, selected) {
    const select = this.el.querySelector(selector)
    if (!select) return

    for (let i = min; i <= max; i++) {
      const option = document.createElement('option')
      option.value = i
      option.text = i
      option.selected = i === selected
      select.add(option)
    }
  }

  initDatePicker() {
    const arrivalInput = this.el.querySelector('#AVP_date_arrival')
    if (!arrivalInput || !this.departureInput) return

    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)

    const isMobile = window.matchMedia('(max-width: 991px)').matches

    this.picker = flatpickr(arrivalInput, {
      mode: 'range',
      locale: French,
      dateFormat: 'd/m/Y',
      showMonths: isMobile ? 1 : 2,
      minDate: 'today',
      defaultDate: [today, tomorrow],
      appendTo: this.el,
      onChange: (selectedDates, _dateStr, instance) => this.handleDateChange(selectedDates, instance),
    })

    // ouvre le même calendrier depuis le champ départ (affichage seul) et les pictos date
    this.departureInput.addEventListener('click', () => this.picker.open())
    this.el.querySelectorAll('.hero-search--icon').forEach((icon) => {
      icon.addEventListener('click', () => this.picker.open())
    })

    this.handleDateChange(this.picker.selectedDates, this.picker)
  }

  handleDateChange(selectedDates, instance) {
    const [arrival, departure] = selectedDates

    // borne la sélection à MAX_NIGHTS tant que la date de départ n'est pas encore posée
    // (sinon la limite posée lors d'un 1er clic sur une arrivée resterait figée pour toujours,
    // empêchant de naviguer au-delà même après une sélection complète)
    if (arrival && !departure) {
      const maxDate = new Date(arrival)
      maxDate.setDate(maxDate.getDate() + MAX_NIGHTS)
      instance.set('maxDate', maxDate)
    } else {
      instance.set('maxDate', null)
    }

    if (arrival) instance.input.value = instance.formatDate(arrival, 'd/m/Y')
    this.departureInput.value = departure ? instance.formatDate(departure, 'd/m/Y') : ''

    this.hiddenArrival.value = arrival ? `${arrival.getFullYear()}-${arrival.getMonth() + 1}-${arrival.getDate()}` : ''
    this.hiddenNights.value = arrival && departure ? this.countNights(arrival, departure) : ''
  }

  countNights(arrival, departure) {
    const arrivalTime = new Date(arrival).setHours(0, 0, 0, 0)
    const departureTime = new Date(departure).setHours(0, 0, 0, 0)
    return Math.round((departureTime - arrivalTime) / 86400000)
  }

  bindSubmit() {
    const submitBtn = this.el.querySelector('#AVP_submit')
    if (!submitBtn) return

    submitBtn.addEventListener('click', () => {
      if (!this.hiddenArrival.value || !this.hiddenNights.value) {
        alert('Merci de sélectionner une date d\'arrivée et de départ')
        return
      }

      this.form.submit()
    })
  }
}
